export const CLOSE_POPUP = 'store/storeDetails/INIT_STORES_VIEW_DETAILS'
export const INIT_STORE_POPUP = 'store/storeDetails/INIT_STORES_VIEW_DETAILS'



// WEBPACK FOOTER //
// ./src/actionTypes/StoreDetailsPopup/storeDetailsPopup.js